import './styles.css';

type LogoProps = {
	avatar: string,
	caption: string | JSX.Element
}
const Logo = ({avatar, caption}: LogoProps): JSX.Element =>  {
	return (
		<>
			<figure className='logo'>
				<img src={avatar} alt='' />
				<figcaption>{caption}</figcaption>
			</figure>
		</>
	);
}

export default Logo;
